module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1217.26113206.png";